"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Z20InventoryDisplay = void 0;
const NinePatch_1 = require("phaser3-rex-plugins/plugins/gameobjects/rendertexture/ninepatch/NinePatch");
const KHContainer_1 = require("./KH/KHContainer");
class Z20InventoryDisplay extends KHContainer_1.KHContainer {
    constructor(scene, cx, cy, setup) {
        const spriteSize = 16;
        const buffer = 10;
        const width = spriteSize + buffer;
        const height = (setup.tools.length + 1) * spriteSize + buffer;
        const sx = cx - (width / 2);
        const sy = cy - (height / 2);
        super(scene, sx, sy, width, height, 0x0, 1, 0, false);
        this.sprites = [];
        this.setDepth(1);
        for (let y = 0; y <= setup.tools.length; y++) {
            const sx = Math.floor((width - spriteSize) / 2);
            const spriteStr = y === 0 ? 'text_youhave' : setup.tools[0].sprite;
            const sprite = scene.add.sprite(sx, buffer / 5 + y * spriteSize, spriteStr).setOrigin(0).setVisible(y === 0);
            this.add(sprite);
            this.sprites.push(sprite);
        }
        const bg = new NinePatch_1.default(scene, {
            x: 0, y: 0, width: width, height: height,
            key: 'border',
            columns: [5, undefined, 5],
            rows: [5, undefined, 5],
        }).setOrigin(0, 0);
        scene.add.existing(bg);
        this.add(bg);
    }
    clearItems() {
        for (let i = 1; i < this.sprites.length; i++) {
            this.sprites[i].visible = false;
        }
    }
    animateClearItems() {
        const visSprites = this.sprites.filter(x => x.visible);
        const visCount = visSprites.length - 1;
        if (visCount <= 0)
            return;
        const colors = [0xffffff, 0xbbbbbb, 0x707070];
        for (let i = 1; i < visSprites.length; i++) {
            const sprite = visSprites[i];
            this.scene.tweens.addCounter({
                from: 0,
                to: 2,
                delay: ((visSprites.length - 1) - i) * 50,
                duration: 100,
                onUpdate: (tween) => {
                    const value = Math.floor(tween.getValue());
                    sprite.setTint(colors[value]);
                },
                onComplete: () => {
                    sprite.visible = false;
                    sprite.setTint(0xffffff);
                }
            });
        }
    }
    addItem(item) {
        for (let spr of this.sprites) {
            if (!spr.visible) {
                spr.setTexture(item.sprite);
                spr.visible = true;
                break;
            }
        }
    }
}
exports.Z20InventoryDisplay = Z20InventoryDisplay;
